import { render, staticRenderFns } from "./ModalProdutoImpostos.vue?vue&type=template&id=a62da9ce"
import script from "./ModalProdutoImpostos.vue?vue&type=script&lang=js"
export * from "./ModalProdutoImpostos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports